module.exports = __webpack_public_path__ + "img/node.88855eb6.png";